import styled from '@emotion/styled';

export const DropzoneStyle = styled.div`
  border: 2px dashed #cccccc;
  padding: 20px;
  text-align: center;
`;

export const ActiveDropzoneStyle = styled(DropzoneStyle)`
  border-color: #0000ff;
`;

export const DropzoneText = styled.p`
  font-size: 16px;
  color: #666666;
`;

export const FileName = styled.span`
    display: "flex",
    fontSize: "14px",
    marginTop: "8px",
`;

export const ImagePreview = styled.img`
  display: "flex",
  width: "100%",
  height: "100%",
  text-align: center;
  paddingLeft: 60px;
  align-items: center;
`;